import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM5.40731 10.5927C5.01679 10.2022 5.01679 9.56899 5.40731 9.17847L6.58579 8L5.40731 6.82152C5.01679 6.431 5.01679 5.79783 5.40731 5.40731C5.79784 5.01679 6.431 5.01679 6.82153 5.40731L8 6.58578L9.17855 5.40723C9.56907 5.01671 10.2022 5.01671 10.5928 5.40723C10.9833 5.79776 10.9833 6.43092 10.5928 6.82145L9.41421 8L10.5928 9.17855C10.9833 9.56907 10.9833 10.2022 10.5928 10.5928C10.2022 10.9833 9.56907 10.9833 9.17855 10.5928L8 9.41421L6.82153 10.5927C6.431 10.9832 5.79784 10.9832 5.40731 10.5927Z",
		fill: "currentColor"
	})
});
export default SvgRemove;
